export default __webpack_public_path__ + "9690ce6275ddc5645cfa2d0162d2e309.woff2";